import _classCallCheck from "/workdir/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workdir/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/workdir/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/workdir/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/workdir/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import '../../packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js';
import '../../packages/@okta/courage-dist/esm/src/courage/framework/Model.js';
import '../../packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js';
import '../../packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js';
import '../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js';
import '../../packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js';
import Model from '../../packages/@okta/courage-dist/esm/src/courage/models/Model.js';
import '../../packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js';
import '../../packages/@okta/courage-dist/esm/src/courage/framework/View.js';
import '../../packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js';
import { mergeHook as _mergeHook } from '../util/Hooks.js';
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

var Hooks = /*#__PURE__*/function (_Model) {
  _inherits(Hooks, _Model);

  var _super = _createSuper(Hooks);

  function Hooks() {
    _classCallCheck(this, Hooks);

    return _super.apply(this, arguments);
  }

  _createClass(Hooks, [{
    key: "mergeHook",
    value: function mergeHook(formName, hookToMerge) {
      var hooks = this.get('hooks') || {};

      _mergeHook(hooks, formName, hookToMerge);

      this.set('hooks', hooks);
    }
  }, {
    key: "getHook",
    value: function getHook(formName) {
      var hooks = this.get('hooks') || {};
      return hooks[formName]; // may be undefined
    }
  }]);

  return Hooks;
}(Model);

export { Hooks as default };